import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=888f47ee&"
import script from "./pagination.vue?vue&type=script&lang=ts&"
export * from "./pagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports